import { defineStore } from "pinia";
import { getPlatform } from "@/utils/platform";
import { Title } from "@/settings";

function isMiniProgramWebviewShell() {
    if (typeof window === "undefined") return false;
    try {
        const search = new URLSearchParams(window.location.search || "");
        return Boolean(search.get("mpNav") || search.get("mpStatus") || search.get("mpMenuTop"));
    } catch (error) {
        return false;
    }
}

function getDefaultTitle() {
    return isMiniProgramWebviewShell() ? Title : import.meta.env.VITE_APP_TITLE || "suplasercut-mobile";
}

export const useAppStore = defineStore("app", {
    state: () => ({
        title: getDefaultTitle(),
        loading: false,
        platform: "",
    }),
    actions: {
        init() {
            if (typeof window === "undefined") {
                return;
            }
            this.platform = getPlatform();
            this.setTitle(getDefaultTitle());
        },
        setTitle(title) {
            this.title = title;
            if (typeof document !== "undefined") {
                document.title = title;
            }
        },
        setLoading(loading) {
            this.loading = !!loading;
        },
    },
});

export function initStore(pinia) {
    useAppStore(pinia).init();
}
